<template>
  <div>
    <section
      v-if="data.enableStats && data.stats"
      class="jwb-module stats md:tw-py-8"
    >
      <div class="container">
        <ul class="the-stats re-li">
          <li
            v-for="(stat, index) in data.stats"
            :key="stat.id"
            class="!tw-my-12"
          >
            <h2
              class="tw-font-shadows tw-text-[#f05b3a] tw-text-[70px] tw-font-light tw-leading-none tw-flex tw-justify-center tw-mb-4"
            >
              {{ stat.prefix_unit }}
              <span
                :data-value="stat.value"
                :ref="
                  (el) => {
                    animatedNumbers[index] = el
                  }
                "
                >0</span
              >
              {{ stat.suffix_unit }}
            </h2>
            <div
              v-html="stat.content"
              class="tw-text-center !tw-text-base md:!tw-text-lg"
            ></div>
          </li>
        </ul>
      </div>
    </section>
    <section v-if="hasContent || data.sButtons" class="tw-py-12 tw-mb-0">
      <div class="tw-max-w-[715px] tw-mx-auto tw-py-0 tw-px-6">
        <div v-html="data.sContent" class="tw-text-center"></div>
        <div v-if="data.addButtons" class="tw-my-8 tw-text-center">
          <a
            v-for="button in data.sButtons"
            :key="button.id"
            class="tw-text-white tw-bg-brand-dark-orange tw-py-4 tw-px-8 tw-border-white tw-border-solid tw-border-2 tw-rounded-full tw-uppercase tw-font-bold tw-font-sans tw-inline-block tw-leading-none hover:tw-text-black hover:tw-bg-white hover:tw-border-black"
            :href="button.s_button_file.url"
            target="_blank"
          >
            {{ button.s_button_text }}
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { gsap } from 'gsap'

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      animatedNumbers: [],
      observers: [],
    }
  },
  computed: {
    hasContent() {
      const strippedText = this.data.sContent
        .replace(/(<([^>]+)>)/gi, '')
        .trim()
      if (!strippedText) return false
      return strippedText.length > 0
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setupNumberAnimation()
    })
  },
  beforeUnmount() {
    // Clean up all observers when component is destroyed
    this.observers.forEach((observer) => observer.disconnect())
  },
  methods: {
    setupNumberAnimation() {
      this.animatedNumbers.forEach((element, index) => {
        if (!element) return

        // Create an Intersection Observer for each element
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.animateNumber(element)
                // Stop observing once animation is triggered
                observer.disconnect()
              }
            })
          },
          { threshold: 0.1 },
        )

        // Start observing the element
        observer.observe(element)

        // Store the observer for cleanup
        this.observers.push(observer)
      })
    },

    animateNumber(element) {
      const endValue = parseInt(element.dataset.value)
      const duration = 4 // seconds
      const startTime = performance.now()

      // Format number with commas
      const formatNumber = (num) => {
        return Math.round(num)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }

      // Animation function
      const updateNumber = (currentTime) => {
        const elapsedTime = currentTime - startTime
        const progress = Math.min(elapsedTime / (duration * 1000), 1)

        // Power2.out easing function
        const easeOutVal = 1 - Math.pow(1 - progress, 2)

        // Calculate current value based on progress
        const currentValue = easeOutVal * endValue

        // Update element with formatted number
        element.innerHTML = formatNumber(currentValue)

        // Continue animation if not complete
        if (progress < 1) {
          requestAnimationFrame(updateNumber)
        }
      }

      // Start animation
      requestAnimationFrame(updateNumber)
    },
  },
}
</script>
